module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-37bc7099.svg";